import { AxiosError, AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query';
import httpClient from 'utils/httpClient';
import { Notification, Pagination } from './type';

export interface NotificationParam {
  isRead?: boolean;
  pageSize: number;
  pageIndex?: number;
}
export interface NotificationResponse {
  notifications: Notification[];
  pagination: Pagination;
}
export const NOTIFICATIONS_ABSENT = 'v2/user/notifications';
export const getInfiniteNotifications = ({
  isRead,
  pageSize,
  pageIndex,
}: NotificationParam) => {
  return httpClient.get<NotificationResponse>(NOTIFICATIONS_ABSENT, {
    params: {
      page: pageIndex,
      isRead: isRead ? undefined : 0,
      'page-size': pageSize,
    },
  });
};
export const useInfiniteNotificaiton = (
  params: NotificationParam,
  options?: UseInfiniteQueryOptions<
    AxiosResponse<NotificationResponse>,
    AxiosError<any>
  >,
) => {
  return useInfiniteQuery(
    [NOTIFICATIONS_ABSENT, params],
    ({ pageParam = { pageIndex: 1 } }) =>
      getInfiniteNotifications({ ...params, pageIndex: pageParam.pageIndex }),
    {
      ...options,
      getNextPageParam: (lastPage, pages) => {
        if (!lastPage.data.pagination.hasMore) {
          return false;
        }
        return {
          pageIndex: lastPage.data.pagination.currentPage + 1,
        };
      },
    },
  );
};
